// router.js
import Vue from 'vue';
import Router from 'vue-router';
 
// 引入组件
import IndexPage from '../view/index.vue';
import HomePage from '../view/centent/index.vue';
import SendPage from '../view/send/index.vue';
import NotFoundPage from '../view/notFoundPage.vue';
 
// 使用Vue Router
Vue.use(Router);
 
// 创建Router实例并定义路由
export default new Router({
    mode: 'history',
    routes: [
        {
        path: '/',
        name: 'IndexPage',
        component: IndexPage
        },
        {
            path: '/export',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/send',
            name: 'SendPage',
            component: SendPage
        },
        {
            // 404
            path: '*',
            name: 'notFound',
            component: NotFoundPage
        }
    ]
});